import { AppContext } from "./AppContext";
import React, { useEffect, useContext, useMemo, useRef, useState } from "react";
import io from "socket.io-client";
import { BASE_URL_CHAT, COUNTRY_LIST } from "../api/ApiConfig";

import useApiService from "../customHooks/useApiService";
import {
  DeleteCallWithErrorResponseWithToken,
  PostCallWithErrorResponse,
  getRequest,
  getWithAuthCallWithErrorResponse,
  getWithRequestBodyWithErrorResponse,
  postMultipartWithProgress,
  postRequest,
  postWithAuthCall,
  simpleGetCall,
  simpleGetCallWithErrorResponse,
  simpleGetCallWithToken,
} from "../api/ApiServices";
import FileSaver from "file-saver";
import ApiConfig from "../api/ApiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { escapeRegExp } from "lodash";
import { toast } from "react-toastify";
import messageTone from "../assets/media/messageTone.mp3";
import ringtone from "../assets/media/ringtone.mp3";
import { BackDropLoader } from "../pages/Pristan Management/LoaderForProston/BackDropLoader";
import { ToastMsg } from "../pages/TostMsg";
import { appInFront, claimDesktopAlert, messageText, showChatToast } from "./chatAlerts";
import { moveChatToFront } from "../utils/moveChatToFront";
import { markDeleted, markEdited } from "../pages/Communication/ChatBox/messageStatus";

const mergeUnreadCounts = (prev, incoming, activeChannelId) => {
  if (!incoming) return prev;
  const isActive = (chat) =>
    activeChannelId != null && chat.Team_Channel_Id == activeChannelId;
  if (!Array.isArray(prev) || !prev.length) {
    return incoming.map((chat) =>
      isActive(chat) ? { ...chat, unread_count: 0 } : chat
    );
  }
  const prevMap = new Map(prev.map((c) => [c.Team_Channel_Id, c]));
  return incoming.map((chat) => {
    if (isActive(chat)) return { ...chat, unread_count: 0 };
    const local = prevMap.get(chat.Team_Channel_Id);
    if (!local) return chat;
    return {
      ...chat,
      unread_count: Math.max(
        Number(chat?.unread_count) || 0,
        Number(local?.unread_count) || 0
      ),
    };
  });
};

const AppState = (props) => {
  // Created once via useRef. Previously this was `let audio = new Audio(messageTone)`
  // which allocated a fresh Audio instance on every provider render —
  // hundreds per minute during chat activity, causing memory pressure
  // and decoder churn. The Audio object is identical across renders so a
  // ref is the correct shape.
  const messageAudioRef = useRef(null);
  if (messageAudioRef.current === null) {
    messageAudioRef.current = new Audio(messageTone);
  }
  // Last total unread count seen from `notification_recieved`. Used to decide
  // whether an incoming event represents a brand-new message (count went up)
  // vs. a read/refresh (count flat or down). `null` until the first event so
  // we don't fire a popup for pre-existing unreads on page load.
  const prevNotifCountRef = useRef(null);
  const [callsLoading, setcallsLoading] = useState(false);
  const [noMorePages, setNoMorePages] = useState(false);
  const [userTyping, setUserTyping] = useState({
    status: false,
    userName: null,
  });
  const [selectedStoreID, setSelectedStoreID] = useState("");
  const [activeTabId, setActiveTabId] = useState(null);
  console.log("activeTabId", activeTabId);

  const [SelectedRestName, setSelectedRestName] = useState(null);
  const [logo, setLogo] = useState({
    companyLogo: "",
    signtureLogo: "",
    terms: "",
  });
  const [SelectedCRMURL, setSelectedCRMURL] = useState(() => {
    // CRMURL is written from SelectedCRMURL; on a fresh load it can be
    // missing while CRMUrlNode (set at login) is present. Both hold the
    // same CRM node URL, so fall back to CRMUrlNode to keep ApiConfig
    // from being built empty.
    return (
      localStorage.getItem("CRMURL") ||
      localStorage.getItem("CRMUrlNode") ||
      ""
    );
  });

const [workPlaceType, setWorkPlaceType] = useState(
  JSON.parse(localStorage.getItem("workSpace"))||{}
);

  // const [ApiConfig, setApiConfigInr] = useState({});
  const [ApiConfigg, setApiConfigInr] = useState(() => {
    const savedConfig = localStorage.getItem("API_CONFIG");
    return savedConfig ? JSON.parse(savedConfig) : {};
  });

  // save to localStorage
  useEffect(() => {
    if (SelectedCRMURL) {
      localStorage.setItem("CRMURL", SelectedCRMURL);
    }
  }, [SelectedCRMURL]);

  // build API config
  useEffect(() => {
    if (!SelectedCRMURL) return;

    const base = SelectedCRMURL + "api/v1/"; //live
    // const base = "https://staging.crm-api.wifiattendance.com:3017/" + "api/v1/"; //stage
    // const base = "http://localhost:3016/" + "api/v1/"; //local pc
    const baseWithoutV1 = SelectedCRMURL + "api/"; //live
    // const baseWithoutV1 = "https://staging.crm-api.wifiattendance.com:3017/" + "api/"; //stage
    // const baseWithoutV1 = "http://localhost:3016/" + "api/"; //local pc
    
    // const base = "http://localhost:3016/" + "api/v1/"; //local  
    const base2 = SelectedCRMURL + "api/";
    // const base2 = "http://192.168.1.17:3016/" + "api/";
    // const base2 = "http://localhost:3016/" + "api/";

    const newConfig = {
      BASE_URL_INVENTORY_SOCKET: `${localStorage.getItem(
        "CRMUrlNode"
      )}`,
      GET_RESTAURANT_MENU: base2 + "menu/v2",
      GET_INVENTORY_PRODUCTS: base + 'products/menu/items-lookup?shop_id=',


      GET_ZAMZAM_USERS: base2 + "contactList",
      ADD_Print: base + "kitchen/",
      PARTAL_UPDATE: base + "products/partal-update",
      deleteproducts: base + "products/delete-products",
      deletecategory: base + "category/delete-categories",
      Update_Print: base + "kitchen/",
      GET_Print_detalis: base + "kitchen/",
      GET_Print_Catagrilist: base + "kitchen/unassigned-categories/",
      GET_Catagrilist_Lookup: base + "kitchen/products-lookup/",
      test_Print: base + "kitchen/test-print",
      List_Print: base + "kitchen?shop_id=",
      DELETE_Print: base + "kitchen/",
      // Print Routing — owner-configurable copies, header tags, duplicate
      // destinations and backup printers. Keyed on the RESTAURANT id
      // (selectedRestID), not the CRM shop id (selectedStoreID); the two are
      // different numbers and mixing them up is a known way to get a screen
      // that looks right while nothing prints.
      GET_PRINT_ROUTING: (restaurantId) =>
        `${base}print-routing?restaurant_id=${restaurantId}`,
      SAVE_PRINT_ROUTING: base + "print-routing",
      PRINT_ROUTING_ACTIVATION: base + "print-routing/activation",
      PRINT_ROUTING_PRESETS: base + "print-routing/presets",
      DELETE_PRINT_ROUTING_PRESET: (presetId) =>
        `${base}print-routing/presets/${presetId}`,
      REVERT_PRINT_ROUTING: (auditLogId) =>
        `${base}print-routing/revert/${auditLogId}`,
      BASE_URL_IN: base,
      GET_STORE: base + "shops/",
      GET_STORE_DROPDOWN: base + "shops/storeDropDown/",
      GET_STORE_Status: base + "shops/202/status",
      GET_STORE_Status_Change: base + "shops/",
      ADD_STORE: base + "shops/",
      UPDATE_STORE: base + "shops/",
      STORE_Detalis: base + "shops/",
      DELETE_STORE: base + "shops/",
      IMPORT_executive: base + "order/print-executive-report",

      GET_STOCK_LIST: base + "products/stockList?",
      RESTOCK_UPDATE: base + "products/restock",

      OrderList: base + "order",
      CHANGE_STAUS_ORDER: base + "order/status",
      ORDER_VIEW_ID: base + "order/",
      // Delivery Address Check — the Order Listing's "Address check" column
      // and its review window. One base, not three getters: this object is
      // saved to localStorage as JSON (API_CONFIG above), which drops
      // functions, and the client in OnlineOrderActivity/addressCheck/
      // builds /by-orders, /:id/apply and /:id/dismiss from it.
      ADDRESS_CORRECTIONS: base + "address-corrections",
      CHAT_VIEW: base + "order/stats?shop_id=",
      REPRINT_ORDER_RECEIPT: base + "order/reprint-order-receipt",

      LIST_MENU_ITEM: base + "products/categories?",
      UPDATE_MENU_ITEM: base + "products/toggle-Active",

      ADDON_ON_OFF_LIST: base + "addons/?shop_id=",
      STORE_ON_OFF: base + "shops/",
      STORE_STATUS: base + "shops/",

      ADD_DISCOUNT_CATREGOREY: base + "discount",
      UPDATE_DISCOUNT_CATREGOREY: base + "discount/",
      GET_DISCOUNT_VIEW: base + "discount/",
      GETDICOUNTLIST: base + "discount?shop_id=",
      categorywisesales: base + "reports/category-wise-sales/print",

      GET_CATEGORY_LIST_DATA: base + "category?shop_id=",
      ADD_CATEGORY: base + "category",
      UPDATE_RANK: base + "category/change-rank-status",
      GET_PARENT_CATEGORY_LIST: base + "category/parent?shop_id=",

      PARENT_UPDATE_RANK: base + "category/parent/change-rank-status",
      UPDATE_PARENT_CATEGORY: base + "category/parent",
      DETAILS_PARENT_CATEGORY: base + "category/parent",
      ADD_PARENT_CATEGORY: base + "category/parent",

      GET_CATEGORY_LIST: base + "category/lookup?",
      GET_VARIATION_LIST: base + "variants?shop_id=",
      GET_VARIATION_LOOKUP: base + "variants/lookup/",
      ADD_VARIATION: base + "variants",
      UNIT_MEASUREMNET: base + "products/unit_of_measurements",
      UPDATE_VARIATION_RANK: base + "variants/change-rank-status",

      GET_TAXES_LIST: base + "tax/?shop_id=",
      ADD_TAXES: base + "tax/",
      TEX_UPDATE_RANK: base + "tax/change-rank",
      DETAILS_TAXES: base + "tax/",

      GET_ITEM_LIST: base + "products/",
      ADD_UPDATE_ITEM: base + "products/",
      TOGGLE_ON_OF: base + "products/toggle-available",
      UPDATE_ACTION: base + "products/action",

      GET_ADDON: base + "addons/lookup/",
      ADD_ADDON: base + "addons",
      GET_ADDONS_BY_ID: base + "addons/?shop_id=",
      GET_ADDON_FOR_UPDATE: base + "addons/",

      ADD_NEW_TABLE: base + "tables",
      TABLES_DATA: base + "tables",
      ADD_DISCOUNT: base + "tables/discount",
      TABLE_ACTION: base + "tables/actions",
      GET_MASTER_AREA: base + "tables/areas/master-lookup",
      GET_TABLE_LOCKUP: base + "tables/lookup?shop_id=",
      ADD_AREA: base + "tables/areas",
      ADD_AREA_DISCOUNT: base + "tables/areas/discount",
      AREA_DISCOUNT: base + "tables/areas/discount",
      ReportExdownlod: base + "reports/item-wise-sales/print",

      GET_HSN_GST: base + "tax/gst",
      GET_SALES_REPORT: base + "reports/item-wise-sales",
      GET_ITEM_WISE_SALES_REPORT_EXPORTS:
        base + "reports/item-wise-sales/export",
      GET_SALES_EXECUTIVE_REPORT: base + "order/daily-sales-report",
      GET_SALES_EXECUTIVE_REPORT_EXPORTS:
        base + "order/daily-sales-report/export",
      POST_ORDER_SUMMARY_REPORT:
        base + "reports/order-summary-report",
      POST_ORDER_SUMMARY_REPORT_EXPORT:
        base + "reports/order-summary-report/export",
      POST_PRICE_UPDATE:
        base + "products/price-update",
      // Category -> item -> variation tree for the bulk price-update modal. Sends
      // menu_id only when a menu version is open, so the prices come back resolved
      // against that menu's overrides rather than the shop's base prices.
      GET_PRICE_UPDATE_LOOKUP: (shopId, menuId) =>
        `${base}products/price-update-lookup?shop_id=${shopId}${
          menuId ? `&menu_id=${menuId}` : ""
        }`,
      POST_SYNC_PET_POOJA:
        base + "products/import-petpooja-items",
      POST_CATEGORY_WISE_REPORT:
        base + "reports/category-wise-sales",
      // ── Agent Order Sales Report ────────────────────────────────────────
      // Orders placed on the Agent Desktop App on a customer's behalf, per
      // agent. Plain strings (the page appends "?" + query) rather than
      // functions: this whole object is saved to localStorage as JSON, which
      // silently drops functions, so a function entry is missing on the first
      // render after a reload.
      GET_AGENT_ORDERS_REPORT: base + "reports/agent-orders",
      GET_AGENT_ORDERS_REPORT_ORDERS: base + "reports/agent-orders/orders",
      GET_AGENT_ORDERS_REPORT_AGENTS: base + "reports/agent-orders/agents",
      GET_AGENT_ORDERS_REPORT_EXPORT: base + "reports/agent-orders/export",
      // ── Call Order Report (Calls + Moved to app) ────────────────────────
      // Plain strings for the same localStorage reason as above.
      GET_CALL_ORDERS_REPORT: base + "reports/call-orders",
      GET_CALL_ORDERS_REPORT_EXPORT: base + "reports/call-orders/export",
      GET_CALL_TO_APP_REPORT: base + "reports/call-to-app",
      GET_CALL_TO_APP_REPORT_EXPORT: base + "reports/call-to-app/export",
      GET_DAY_WISE_SALES_REPORT: base + "reports/restaurants-day-wise-sales",
      GET_DAY_WISE_SALES_REPORT_EXPORT:
        base + "reports/restaurants-day-wise-sales/export",
      POST_CATEGORY_WISE_SALES_REPORT_EXPORT:

        base + "reports/category-wise-sales/export",
      IMPORT_PRODUCTS: base + "products/import-excel",
      EXPORT_PRODUCTS: (id, format, menuId) => {
        const params = new URLSearchParams();
        if (format) params.append("format", format);
        if (menuId) params.append("menu_id", menuId);
        const qs = params.toString();
        return `${base}products/${id}/export-excel${qs ? `?${qs}` : ""}`;
      },

      // ── Inventory Activity Log (read-only audit trail) ─────────────────
      // The path is /api/v1/audit-log, NOT /api/audit-log — the shorter one
      // belongs to the CRM chatbot's unrelated audit table on the backend.
      GET_ACTIVITY_LOG: (qs) => `${base}audit-log${qs ? `?${qs}` : ""}`,
      GET_ACTIVITY_LOG_DETAIL: (id) => `${base}audit-log/${id}`,
      GET_ACTIVITY_LOG_GROUP: (qs) => `${base}audit-log/group${qs ? `?${qs}` : ""}`,
      GET_ACTIVITY_LOG_ACTORS: (qs) => `${base}audit-log/actors${qs ? `?${qs}` : ""}`,

      // ── Agent Desktop App Logs (diagnostics uploaded by restaurant PCs) ──
      // Mounted at /api/v1/support/* on the inventory node. The download route
      // streams the gzip THROUGH the server rather than handing out a presigned
      // S3 URL, so it needs the same Bearer token as everything else here —
      // which is why the screen uses a raw fetch for it and not simpleGetCall
      // (that helper JSON.parses every response and would destroy a gzip).
      GET_AGENT_MACHINES: (qs) => `${base}support/agents${qs ? `?${qs}` : ""}`,
      GET_AGENT_BUNDLES: (qs) => `${base}support/log-bundles${qs ? `?${qs}` : ""}`,
      GET_AGENT_BUNDLE_DETAIL: (id) => `${base}support/log-bundles/${id}`,
      DOWNLOAD_AGENT_BUNDLE: (id) => `${base}support/log-bundles/${id}/download`,
      // "Get logs now": mints a single-use ticket and tells one machine to
      // upload. Returns a command_id, which the bundle it produces carries back
      // — so the screen can wait for that exact bundle rather than guessing.
      POST_AGENT_REQUEST_UPLOAD: () => `${base}support/log-bundles/request`,
      // "We have fixed the server — stop waiting." The agent parks uploads for
      // six hours after five consecutive failures and remembers that across
      // restarts, so a repaired backend used to mean up to six MORE hours of
      // silence per machine with no way to end it. This clears that backoff over
      // the socket the agent already holds. Send {} to wake the whole tenant,
      // which is the shape this is actually for.
      POST_AGENT_RESUME_UPLOADS: () => `${base}support/log-bundles/resume`,

      GET_RESTAURANT_CONFIG: base2 + "restaurant/restaurant-config",
      POST_RESTAURANT_CONFIG: (id) => `${base}shops/${id}/config`,
      GET_MENU: (id) => `${base}products/menu?shop_id=${id}`,
      GET_MENU_ITEMS: (storeId, menuId) => `${base}products/menu/items-lookup?shop_id=${storeId}&menu_id=${menuId}`,
      POST_CREATE_MENU: base + "products/menu",
      PUT_UPDATE_MENU: (id) => `${base}products/menu/${id}`,
      POST_SWITCH_MENU : base + "products/menu/switch",
      GET_ITEM_VARIANTS: (prodId, menuId) => `${base}products/${prodId}/variants${menuId != null && menuId !== undefined ? `?menu_id=${menuId}` : ""}`,
      PUT_ITEM_VARIANTS: (prodId, menuId) => `${base}products/${prodId}/variants${menuId != null && menuId !== undefined ? `?menu_id=${menuId}` : ""}`,
      DELETE_ITEM_VARIANT: (prodId, variationId, menuId) => `${base}products/${prodId}/variants/${variationId}${menuId != null && menuId !== undefined ? `?menu_id=${menuId}` : ""}`,

      GET_WALLET_ADMIN_CAMPAIGNS:  baseWithoutV1 + "wallet/admin/campaigns",
      GET_WALLET_ADMIN_GAMIFICATION_RULES: baseWithoutV1 + "wallet/admin/gamification-rules",
      GET_WALLET_ADMIN_REPORTS_OUTCOME: baseWithoutV1 + "wallet/admin/reports/outcome",
      GET_WALLET_ADMIN_REFERRALS: baseWithoutV1 + "wallet/admin/referrals",
      GET_WALLET_ADMIN_REFERRALS_STATS: baseWithoutV1 + "wallet/admin/referrals/stats",
      GET_WALLET_ADMIN_REDEMPTION_RULES: baseWithoutV1 + "wallet/admin/redemption-rules",
      // CRM › Call-backs: the Call follow-up campaign's list (phonebook-node
      // docs/call-followup-campaign.md), and the backend's own click-to-call
      // (POST /api/make-call, VoxBay) for its Call button.
      GET_WALLET_ADMIN_CALL_CALLBACKS: baseWithoutV1 + "wallet/admin/call-callbacks",
      POST_NODE_MAKE_CALL: baseWithoutV1 + "make-call",
      GET_MARK_USER_LIST : baseWithoutV1 + "mark_users",

      // Push Notification Campaigns (Promo Wallet)
      GET_PROMOTIONAL_MESSAGES: baseWithoutV1 + "promotional-messages",
      // The campaign queue: one row per distinct notification, each
      // carrying the title and body it sends, plus the schedule fields
      // (run_time, weekday, when/time labels, occurrences…) that the
      // flat promotional-messages list doesn't have. Source for both
      // the push campaigns list screen and the multi campaign form's
      // message picker.
      GET_PUSH_CAMPAIGNS: baseWithoutV1 + "push-campaigns",
      GET_PUSH_CAMPAIGN_BY_ID: (id) => `${baseWithoutV1}push-campaigns/${id}`,
      PATCH_PUSH_CAMPAIGN: (id) => `${baseWithoutV1}push-campaigns/${id}`,
      DELETE_PUSH_CAMPAIGN: (id) => `${baseWithoutV1}push-campaigns/${id}`,
      // One request for a whole selection instead of one DELETE per row —
      // a closed tab mid-loop used to leave a selection half-deleted with
      // no record of which half. Body is `{ ids: [...] }`, 1-500 ids.
      BULK_DELETE_PUSH_CAMPAIGNS: baseWithoutV1 + "push-campaigns/bulk-delete",
      POST_PROMOTIONAL_MESSAGE: baseWithoutV1 + "promotional-messages",
      GET_PROMOTION_GROUPS: baseWithoutV1 + "promotion-groups",
      POST_PROMOTION_GROUP: baseWithoutV1 + "promotion-groups",
      GET_USER_LIST: baseWithoutV1 + "getUserList",
      POST_ADD_MEMBERS_TO_GROUP: (id) => `${baseWithoutV1}addMembersToGroup/${id}`,
      GET_PROMOTIONAL_MESSAGE_BY_ID: (id) => `${baseWithoutV1}promotional-messages/${id}`,
      POST_CANCEL_PROMOTION_MESSAGE: (id) =>
        `${baseWithoutV1}cancelPromotionMessage/${id}`,
    };

    // Save to state
    setApiConfigInr(newConfig);

    // Save full API config in localStorage
    localStorage.setItem("API_CONFIG", JSON.stringify(newConfig));
  }, [SelectedCRMURL]);

  console.log("ApiConfig", ApiConfigg);
  const [formFormat, setFormFormat] = useState("left");

  const [selectedRestID, setSelectedRestID] = useState(
    localStorage.getItem("selectedStoreRestID") || null
  );
  const [storesList, setstoresList] = useState("");
  const [storeMenusTabs, setStoreMenusTabs] = useState("");
  const [parentCategory, setParentCategory] = useState(false);
  const [activeTab, setActiveTab] = useState("Items"); // Lift the state up
  const [parentTab, setParentTab] = useState(null);
  console.log("parentTab", parentTab);

  const [openSessionLogoutModal, setOpenSessionLogoutModal] = useState(false);
  const [isCallHistory, setIsCAllHistory] = useState(false);
  const [loadworkFlowTaskForm, setLoadWorkFlowTaskForm] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const [conversations, setConversations] = useState([]);
  const [sidebar, setSidebar] = useState(true);
  const [noOfRows, setNoOfRows] = useState(0);
  const [backdrop, setbackdrop] = useState(false);
  // The header's theme switch is kept for the browser: after switching to
  // dark, the next page load was light again (Usability Retest 2, R2).
  const [Dark, setDarkState] = useState(() => {
    try {
      return localStorage.getItem("themeMode") === "darkMode" ? "darkMode" : "lightMode";
    } catch {
      return "lightMode";
    }
  });
  const setDark = (mode) => {
    setDarkState(mode);
    try {
      localStorage.setItem("themeMode", mode);
    } catch {
      // Private mode or blocked storage: the choice lasts for this visit only.
    }
  };
  const [callPage, setCallPage] = useState(0);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [profile, setprofile] = useState(false);
  const [paginationLoader, setPaginationLoader] = useState(false);
  const [sateUpdater, setSateUpdater] = useState(false);
  const [temp, settemp] = useState(false);
  const [activeChat, setActiveChat] = useState({});
  const [currentSChannel, setCurrentSChannel] = useState(null);
  // Set by global search (Chat.js) when a message hit opens a
  // conversation that isn't the one already active — ChatBox picks it
  // up once that channel's first page of `conversations` has loaded to
  // decide whether the target message is on screen (a live scroll-to)
  // or needs the same detached context window in-conversation search
  // already falls back to for a message outside the loaded range. Never
  // read outside that one handoff; cleared as soon as ChatBox acts on it.
  const [pendingSearchJump, setPendingSearchJump] = useState(null);
  const currentSChannelRef = useRef(currentSChannel);
  useEffect(() => {
    currentSChannelRef.current = currentSChannel;
  }, [currentSChannel]);
  const [socket, setSocket] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [suggetions, setSuggetions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessages, setNewMessages] = useState([]);
  const [recentChats, setRecentChats] = useState([]);

  const [pinnedChats, setPinnedChats] = useState([]);
  const [editMsg, setEditMsg] = useState({});
  const [projects, setProjects] = useState([]);
  const [teams, setTeams] = useState([]);
  const [replyTo, setReplyTo] = useState({});
  const [page, setPage] = useState(0);
  const currentRoute = useLocation().pathname;
  const [callDetaiils, setCallDetaiils] = useState({});
  const [userCalling, setUserCalling] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMemberslist, setTeamMembersList] = useState([]);
  const [currentTeam, setCurrentTeam] = useState(null);
  const [callHystory, setCallHystory] = useState([]);
  const [membersArray, setMembersArray] = useState([]);
  const [msgdelete, setmsgdelete] = useState(false);
  const [masterData, setMasterData] = useState({
    isFetched: false,
  });
  const [taskAllocationStatus, setTaskAllocationStatus] = useState([]);

  const [percentage, setPercentage] = useState(0);
  console.log(percentage);
  //   const dispach = useDispatch();
  const [tokendatacontaxt, settokendatacontaxt] = useState("");
  const [hide, sethide] = useState(false);
  const [Pecentagedata, setPecentagedata] = useState("");
  const [customerData, setCustomerData] = useState({
    api_key: localStorage.getItem("api_key")
      ? localStorage.getItem("api_key")
      : null,

    User_id: localStorage.getItem("User_id")
      ? localStorage.getItem("User_id")
      : null,
    token: localStorage.getItem("Token") ? localStorage.getItem("Token") : "",
  });

  function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }

  useEffect(() => {
    if (customerData.customer_id) {
    }
  }, [customerData.customer_id]);

  console.log("customerData", customerData);
  const [ChangeLang, SetChangeLang] = useState("en");
  const [PageMsg, SetPageMsg] = useState("");
  const [codequerylgin, setcodequerylgin] = useState(false);
  const [userlgin, setUserlgin] = useState(false);

  const [backNav, setBackNav] = useState({});

  const handleSetBack = (key, val) => {
    setBackNav((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const [ChannelId, setChannelId] = useState([]);
  const [SubChannelId, setSubChannelId] = useState([]);

  const [selectedProjectName,setSelectedProjectName]=useState('')
  const [domainsMapWithProjects,setomainMapsWithProject] = useState([])

  const [CallLoadMore, setCallLoadMore] = useState(true);
  const [recentChatLdr, setRecentChatLdr] = useState(false);
  const [chatCount, setChatCount] = useState(0);
  const [unreadProjectCount, setUnreadProjectCount] = useState(0);
  const [unreadTeamCount, setUnreadTeamCount] = useState(0);
  const [teamList, setTeamList] = useState([]);
  const [pendingWorkflowTaskCount, setPendingWorkflowTaskCount] = useState(0);
  const [isNormal, setIsNormal] = useState(false);
  const [uniqueCode, setUniqueCode] = useState();

  const [countryList, setCountryList] = useState({
    countries: [],
    isFetched: false,
  });

  const storedText = (key) => {
    const v = localStorage.getItem(key);
    return v && v !== "null" && v !== "undefined" ? v : null;
  };
  const [userData, setUserData] = useState({
    Token: localStorage.getItem("Token") ? localStorage.getItem("Token") : null,
    Username: localStorage.getItem("Username")
      ? localStorage.getItem("Username")
      : null,
    UserId: localStorage.getItem("UserId")
      ? localStorage.getItem("UserId")
      : null,
    Permissions: localStorage.getItem("Permissions")
      ? localStorage.getItem("Permissions")
      : null,
    Image: localStorage.getItem("Image") ? localStorage.getItem("Image") : null,
    // A login response with no last name was stored as the string "null"
    // (localStorage keeps strings), which then showed up in names built
    // from the two parts ("Ashmer Shaikh null" on a source row).
    FirstName: storedText("FirstName"),
    LastName: storedText("LastName"),
    Email: localStorage.getItem("Email") ? localStorage.getItem("Email") : null,
    // Saved at login (storeLoginData) but was never restored here, so after any
    // page refresh userData.Mobile was undefined and the CRM Admin screens, which
    // send it as `agent_number`, dead-ended on "No phone number on this account".
    Mobile: localStorage.getItem("Mobile") ? localStorage.getItem("Mobile") : null,
    EmpId: localStorage.getItem("EmpId") ? localStorage.getItem("EmpId") : null,
    OrgId: localStorage.getItem("OrgId") ? localStorage.getItem("OrgId") : null,
    CRMUrlNode: localStorage.getItem("CRMUrlNode")
      ? localStorage.getItem("CRMUrlNode")
      : "",

    CompanyLogo: localStorage.getItem("CompanyLogo")
      ? localStorage.getItem("CompanyLogo")
      : null,

    locationId: localStorage.getItem("locationId")
      ? localStorage.getItem("locationId")
      : "",
  });

  const [headerProfile, setHeaderProfile] = useState(
    localStorage.getItem("Image") || ""
  );
  const [projectIdTast, setprojectIdTast] = useState();
  const [intentAndKeywords, setIntentAndKeywords] = useState([
    { intent: "", keyword: "", err: "" },
  ]);

  const [yearsFromJoining, setYearsFromJoining] = useState({
    isFetch: false,
    years: [],
  });

  const { isLoading, error, get, post, put } = useApiService();

  const [permissions, setPremissions] = useState(
    JSON.parse(localStorage.getItem("Permissions"))
      ? JSON.parse(localStorage.getItem("Permissions"))
      : {}
  );
  useEffect(() => {
    setConversations([]);
    // setActiveChat({})
    setNewMessages([]);
    // setCurrentSChannel(null)
    setReplyTo({});
    setEditMsg({});
  }, [currentRoute]);
  let geAllusers = () => {
    getWithAuthCallWithErrorResponse(ApiConfig.SEARCH_ALL + "").then((res) => {
      if (res && res.json.success) setSuggetions(res?.json.data);
    });
  };

  // Tracks which socket instance the heavy post-login bootstrap (geAllusers,
  // getTeams, getProjects, getCallDetails, get-private-chat-list emit) has
  // already run for. Prevents re-firing on every navigation while still
  // letting it run once per logged-in session.
  const heavyBootstrapDoneRef = useRef(null);

  useEffect(() => {
    // Share-link guest pages (/s) never open the chat socket.
    if (userData.Token && !/^\/s(\/|$)/.test(window.location.pathname)) {
      setSocket(
        io(BASE_URL_CHAT, {
          query: { token: localStorage.getItem("Token"), os_type: "web" },
        })
      );
    }
    // Only re-create the socket when the auth token actually changes —
    // depending on the whole `userData` object rebuilt the socket (and
    // re-attached every listener) on unrelated user-profile updates.
  }, [userData.Token]);

  // Effect 1: socket-bound listeners that the SIDEBAR depends on.
  // Runs once per socket instance — attaches `notification-count` (sidebar
  // badge counts) and the `get-private-chat-list` response handler. The
  // handler is cheap to leave attached; it only fires when somebody emits.
  useEffect(() => {
    if (!socket) return;

    socket.on("notification-count", (data) => {
      setNotifications(data.notifications);
      setChatCount(data.private_unread_notification_count);
      setUnreadProjectCount(data?.project_unread_notification_count);
      setUnreadTeamCount(data?.team_unread_notification_count);
      setUnreadCount(data.notification_count);
    });

    socket.on("get-private-chat-list", (data) => {
      console.log("get-private-chat-list response:", data);
      setPinnedChats((prev) =>
        mergeUnreadCounts(prev, data.pinned, currentSChannelRef.current)
      );
      setRecentChats((prev) =>
        mergeUnreadCounts(prev, data.recent, currentSChannelRef.current)
      );
      setRecentChatLdr(false);
    });

    return () => {
      socket.off("notification-count");
      socket.off("get-private-chat-list");
    };
  }, [socket]);

  // Effect 2: msgdelete-specific chat-list handler (preserves original
  // semantics: when a message is deleted, re-attach the listener so the
  // refreshed list flows back through the same merge logic).
  useEffect(() => {
    if (!socket || msgdelete !== true) return;

    const handler = (data) => {
      setPinnedChats((prev) =>
        mergeUnreadCounts(prev, data.pinned, currentSChannelRef.current)
      );
      setRecentChats((prev) =>
        mergeUnreadCounts(prev, data.recent, currentSChannelRef.current)
      );
      setRecentChatLdr(false);
    };
    socket.on("get-private-chat-list", handler);

    return () => {
      socket.off("get-private-chat-list", handler);
      setmsgdelete(false);
    };
  }, [socket, msgdelete]);

  // Effect 3: deferred heavy bootstrap. The original code fired geAllusers,
  // getTeams, getProjects, getCallDetails AND emitted `get-private-chat-list`
  // immediately after socket connect — which froze the sidebar for several
  // seconds for org-owner accounts (huge user/team/project/chat datasets).
  // Now the bootstrap waits until the user actually navigates to a route
  // that needs that data; the sidebar's badge counts come from `notification-count`
  // (Effect 1) and the Chat/Teams/Projects pages emit their own fetches.
  useEffect(() => {
    if (!socket) return;
    if (heavyBootstrapDoneRef.current === socket) return;

    const HEAVY_PREFIXES = [
      "/chat",
      "/projects",
      "/teams",
      "/Call",
      "/ongoing-calls",
      "/chathistory",
    ];
    const onHeavyRoute = HEAVY_PREFIXES.some(
      (p) => currentRoute === p || currentRoute.startsWith(p + "/")
    );
    if (!onHeavyRoute) return;

    heavyBootstrapDoneRef.current = socket;
    geAllusers();
    getTeams();
    getProjects();
    getCallDetails();
    // Chat page mounts its own emit, so skip ours when the user is already there.
    if (currentRoute !== "/chat" && !currentRoute.startsWith("/chat/")) {
      socket.emit("get-private-chat-list");
    }
  }, [socket, currentRoute]);

  useEffect(() => {
    if (currentSChannel) getPrivateChatConversation(true);
  }, [page]);

  // const getTeams = () => {
  //   socket && socket.emit('get-project-channels', {})
  // }

  const getProjects = () => {
    socket && socket.emit("get-projects-android", {});
  };

  const getTeams = () => {
    socket && socket.emit("get-teams-android", {});
  };
  // get-teams-android

  const searchFilter = (e) => {
    setFilteredUsers(
      suggetions.filter(
        (user) =>
          user.FirstName.toLowerCase().includes(e.target.value) ||
          user.LastName.toLowerCase().includes(e.target.value)
      )
    );
  };

  useEffect(() => {
    getCallDetails();
  }, [callPage]);

  const getCallDetails = () => {
    // setcallsLoading(true)
    // console.log(callPage);
    // socket && socket.emit("call-history",{page:callPage})
  };
  useEffect(() => {
    socket &&
      socket.on("notification_recieved", (data) => {
        console.log("notification_recieved:", {
          team_unread_notification_count: data?.team_unread_notification_count,
          project_unread_notification_count: data?.project_unread_notification_count,
          private_unread_notification_count: data?.private_unread_notification_count,
        });

        // ---- Sound + desktop popup for a brand-new incoming notification ----
        // This event is the user's GLOBAL push (fires on any page), so it's
        // the reliable place to alert — `message-sent` only reaches you when
        // you've joined that specific chat room.
        {
          const newCount = Number(data?.notification_count) || 0;
          const prevCount = prevNotifCountRef.current;
          prevNotifCountRef.current = newCount;
          console.log("[notify] notification_recieved counts", {
            prevCount,
            newCount,
            willAlert: prevCount != null && newCount > prevCount,
          });
          // Skip the first event (initial sync) and only alert when the unread
          // total actually grew — i.e. a genuinely new message arrived.
          if (prevCount != null && newCount > prevCount) {
            const tone = messageAudioRef.current;
            if (tone) {
              try {
                tone.currentTime = 0;
                const played = tone.play();
                if (played && typeof played.catch === "function")
                  played.catch(() => {});
              } catch (e) {
                /* ignore autoplay errors */
              }
            }

            const latest =
              Array.isArray(data?.notifications) && data.notifications.length
                ? data.notifications[0]
                : null;
            const senderName = latest
              ? `${latest.FirstName || ""} ${latest.LastName || ""}`.trim()
              : "";
            const verb =
              latest && latest.notification_type === "mention"
                ? "Mentioned you"
                : "Sent you a message";
            const where =
              latest && latest.channel_name && latest.channel_name !== "private"
                ? ` in ${latest.channel_name}-${latest.Team_Channel_Name || ""}`
                : "";

            const popupTitle = senderName || "New message";
            const text = messageText(latest);
            const popupBody = text ? `${where ? `${where.trim()}: ` : ""}${text}` : `${verb}${where}`;

            // OS-level desktop popup (needs permission + secure context): only
            // when the app is not in front, and once across open tabs — on
            // screen the in-app popup is enough (feedback 4 Nov: both showed,
            // and each tab added its own).
            if (!appInFront() && claimDesktopAlert(`${popupTitle}|${latest ? latest.Team_Channel_Id : ""}|${newCount}`)) {
              showDesktopNotification({ title: popupTitle, body: popupBody });
            }

            // In-app popup: at most two on screen, one per chat, with the
            // message itself (chatAlerts.js).
            showChatToast({
              key: latest ? latest.Team_Channel_Id : "",
              who: popupTitle,
              what: verb,
              where,
              text,
            });
          }
        }

        setUnreadTeamCount(data?.team_unread_notification_count);
        setNotifications(data.notifications);
        setUnreadCount(data.notification_count);

        console.log("[chatCount badge]", {
          previous: chatCount,
          incoming: data.private_unread_notification_count,
          willUpdate: chatCount != data.private_unread_notification_count,
        });
        chatCount != data.private_unread_notification_count &&
          setChatCount(data.private_unread_notification_count);

        setUnreadProjectCount(data?.project_unread_notification_count);

        data?.project_unread_notification_count != unreadProjectCount &&
          getProjects();

        data?.team_unread_notification_count != unreadTeamCount && getTeams();

        const privateNotifs = Array.isArray(data?.notifications)
          ? data.notifications.filter((n) => n?.channel_name === "private")
          : [];
        const unreadByChannel = privateNotifs.reduce((map, n) => {
          const cid = n?.Team_Channel_Id;
          if (cid != null) map[cid] = (map[cid] || 0) + 1;
          return map;
        }, {});

        const applyDerivedUnread = (chat) => {
          if (!chat || chat.Team_Channel_Id == null) return chat;
          const isActive = chat.Team_Channel_Id == currentSChannel;
          return {
            ...chat,
            unread_count: isActive
              ? 0
              : unreadByChannel[chat.Team_Channel_Id] || 0,
          };
        };

        setRecentChats((prev) =>
          prev && prev.length ? prev.map(applyDerivedUnread) : prev
        );
        setPinnedChats((prev) =>
          prev && prev.length ? prev.map(applyDerivedUnread) : prev
        );

        socket && socket.emit("get-private-chat-list");
      });

    return () => {
      if (socket) {
        socket.off("notification_recieved");
      }
    };
  }, [socket, currentSChannel, userData]);

  const getPendingWorkflowTaskCount = () => {
    simpleGetCallWithErrorResponse(
      ApiConfig?.GET_PENING_INPROGEES_TASK_COUNT
    ).then((res) => {
      if (res?.json?.Success) {
        setPendingWorkflowTaskCount(res?.json?.Data);
      }
    });
  };

  useEffect(() => {
    getPendingWorkflowTaskCount();
  }, [userData]);

  // Ask the browser for desktop-notification permission as soon as the app
  // loads. If the browser refuses to prompt without a gesture, the unlock
  // effect below retries on the first click. Surface the outcome so the user
  // knows why the cross-screen desktop popup may not appear.
  useEffect(() => {
    if (typeof window === "undefined" || !("Notification" in window)) return;
    // Share-link guests (/s/<token>) get no notifications (share-link spec §3.4).
    if (/^\/s(\/|$)/.test(window.location.pathname)) return;
    if (!window.isSecureContext) {
      console.log(
        "[notify] NOT a secure context — desktop popups are disabled. Open the app via http://localhost:PORT or https."
      );
      return;
    }
    if (Notification.permission === "granted") return;
    if (Notification.permission === "denied") {
      toast.warn(
        "Desktop notifications are blocked. Click the padlock in the address bar → Notifications → Allow to get popups while you're in another window.",
        { autoClose: 6000, position: "top-right" }
      );
      return;
    }
    Notification.requestPermission()
      .then((perm) => {
        if (perm !== "granted") {
          toast.info(
            "Enable notifications to see message popups while you're in another app or window.",
            { autoClose: 6000, position: "top-right" }
          );
        }
      })
      .catch(() => {});
  }, []);

  // The first user gesture unlocks two browser gates at once:
  //   1. The autoplay policy — priming the tone here means the later
  //      .play() fired from the `message-sent` handler isn't blocked.
  //   2. The notification permission prompt — some browsers only surface it
  //      in response to a real user interaction.
  useEffect(() => {
    if (typeof window === "undefined") return;
    const unlock = () => {
      const tone = messageAudioRef.current;
      if (tone) {
        tone
          .play()
          .then(() => {
            tone.pause();
            tone.currentTime = 0;
          })
          .catch(() => {});
      }
      if (
        "Notification" in window &&
        Notification.permission === "default"
      ) {
        Notification.requestPermission().catch(() => {});
      }
    };
    window.addEventListener("pointerdown", unlock, { once: true });
    return () => window.removeEventListener("pointerdown", unlock);
  }, []);

  // Raises a native OS popup for an incoming chat message. This is the popup
  // that appears OVER other apps / other Chrome windows / other screens even
  // when this tab isn't focused — but only if permission was granted on a
  // secure (https/localhost) context.
  const showDesktopNotification = ({ title, body }) => {
    try {
      if (typeof window === "undefined" || !("Notification" in window)) {
        console.log("[notify] Notification API not available in this browser");
        return;
      }
      console.log("[notify] permission =", Notification.permission, {
        secureContext: window.isSecureContext,
        title,
        body,
      });
      if (Notification.permission !== "granted") {
        console.log("[notify] blocked — permission is not 'granted'");
        return;
      }

      const options = {
        body: body || "You have a new message",
        icon: "/icon.png",
        badge: "/icon.png",
        tag: "wifiattendance-chat",
        // Re-alert even though we reuse the same tag, so a second message
        // visibly refreshes the popup instead of being silently merged.
        renotify: true,
        // Keep the popup on screen until the user acts on it — important when
        // they're in another app and glance over a few seconds later.
        requireInteraction: true,
      };

      // Prefer the Service Worker path when one is active: some browsers only
      // reliably display notifications via the SW when the tab is in the
      // background / on another screen. Fall back to the plain constructor.
      if (
        "serviceWorker" in navigator &&
        navigator.serviceWorker.controller &&
        navigator.serviceWorker.ready
      ) {
        navigator.serviceWorker.ready
          .then((reg) => reg.showNotification(title || "New message", options))
          .catch(() => {
            const n = new Notification(title || "New message", options);
            n.onclick = () => {
              window.focus();
              n.close();
            };
          });
        return;
      }

      const notification = new Notification(title || "New message", options);
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    } catch (e) {
      /* notifications are best-effort; ignore failures */
    }
  };

  useEffect(() => {
    socket &&
      socket.on("message-sent", (data) => {
        if (
          (recentChats &&
            !recentChats.filter(
              (chat) => chat.Team_Channel_Id == data.schannel_id
            ).length) ||
          (pinnedChats &&
            !pinnedChats.filter(
              (chat) => chat.Team_Channel_Id == data.schannel_id
            ).length)
        )
          setReplyTo({});
        setEditMsg({});

        const isMyMessage = data.Sender_Id == userData?.EmpId;
        const isActiveChannel = data.schannel_id == currentSChannel;

        // Sound only while you're actively viewing this chat — gives in-chat
        // audio feedback. The desktop popup (and the background sound) is
        // handled by the `notification_recieved` handler so we don't double up.
        if (!isMyMessage && isActiveChannel) {
          const tone = messageAudioRef.current;
          if (tone) {
            try {
              tone.currentTime = 0;
              const played = tone.play();
              if (played && typeof played.catch === "function")
                played.catch(() => {});
            } catch (e) {
              /* ignore autoplay errors */
            }
          }
        }

        if (isActiveChannel) {
          setNewMessages((pre) => [
            ...pre,
            {
              ...data,
              reactions: [
                {
                  reaction_id: "",
                  reaction: "",
                  reacted_by: "",
                },
              ],
            },
          ]);

          if (!isMyMessage)
            socket &&
              socket.emit("update-last-msg-read", {
                schannel_id: currentSChannel,
                LastMsgId: data.message_id,
              });
        }

        const applyIncomingMessage = (chat) => {
          if (chat.Team_Channel_Id != data.schannel_id) return chat;
          const shouldIncrement = !isMyMessage && !isActiveChannel;
          return {
            ...chat,
            lastmessage: data.message,
            unread_count: shouldIncrement
              ? (Number(chat.unread_count) || 0) + 1
              : isActiveChannel
                ? 0
                : chat.unread_count,
          };
        };

        // Newest activity first, at once (QA CM-06): the server orders
        // Recent by last message, but nothing re-sorted it here after a
        // send, so the row kept its place until a reload. Covers your own
        // sends and messages arriving in rooms you've joined. Pinned keeps
        // its own order.
        setRecentChats((prev) =>
          moveChatToFront(prev, data.schannel_id, applyIncomingMessage)
        );
        setPinnedChats((prev) =>
          prev && prev.length ? prev.map(applyIncomingMessage) : prev
        );
      });
    return () => {
      if (socket) {
        socket.off("message-sent");
      }
    };
  }, [socket, currentSChannel, userData, newMessages]);

  const handleEditDocument = async (id, payLoad) => {
    const res = await PostCallWithErrorResponse(
      ApiConfig.UPDATE_DOCUMENT + id,
      JSON.stringify(payLoad)
    );

    if (res?.json?.Success) {
      ToastMsg("success", res?.json?.Message);

      return true;
    } else {
      ToastMsg("error", res?.json?.Message);

      return false;
    }
  };

  const deleteDocument = async (id, url) => {
    let res = await DeleteCallWithErrorResponseWithToken(url + id);

    if (res?.json?.Success) {
      ToastMsg("success", res?.json?.Message);

      return true;
    } else {
      ToastMsg("error", res?.json?.Message);

      return false;
    }
  };

  const downloadDocument = (id, url) => {
    simpleGetCallWithErrorResponse(url + id).then((res) => {
      if (res?.json?.Success) {
        const { FileContents, FileDownloadName, ContentType } = res?.json?.Data;

        FileSaver.saveAs(
          "data:" + ContentType + ";base64," + FileContents,
          FileDownloadName
        );

        ToastMsg("success", res?.json?.Message);
      } else {
        ToastMsg("error", res?.json?.Message);
      }
    });
  };

  useEffect(() => {
    socket &&
      socket.on("member-added", (data) => {
        socket && socket.emit("get-members", { schannel_id: data.schannel_id });
        if (currentRoute.includes("projects")) {
          getProjects();
          getTeams();
        }
      });
    socket &&
      socket.on("member-removed", (data) => {
        socket && socket.emit("get-members", { schannel_id: data.schannel_id });
        if (currentRoute.includes("projects")) {
          getProjects();
          getTeams();
          // getTeams()
        }
      });
    socket &&
      socket.on("get-members", (data) => {
        if (data.schannel_id === currentSChannel) {
          let arr = [...data?.result?.sort((a, b) => a.User_Id - b.User_Id)];

          if (data?.result?.length > 2) {
            arr.push({
              User_Id: "everyone",
              FirstName: "Everyone",
              LastName: "",
            });
          }

          setMembersArray(arr);
          let active = { ...activeChat };
          active.em = data.result;
          setActiveChat({ ...active });
        }
      });
    socket &&
      socket.on("get-general-members", (data) => {
        // let arr = [...data?.result?.sort((a, b) => a.User_Id - b.User_Id)];

        // if (data?.result?.length > 2) {
        //   arr.push({
        //     User_Id: "everyone",
        //     FirstName: "Everyone",
        //     LastName: "",
        //   });
        // }

        // console.log("getnereal members array", data.result)

        // setGenralMembersArray(data.result);
        // let active = { ...activeChat };
        // active.em = data.result;
        // setActiveChat({ ...active });

        data.result.filter((user) => user.User_Id != userData.EmpId);
      });
    socket &&
      socket.on("message-edited", (data) => {
        setEditMsg({});
        // markEdited also sets IsEdit and an edit time, so "Edited" shows
        // at once for the editor and everyone else in the room (QA CM-05).
        setConversations(
          conversations.map((msg) => {
            return msg.Team_Message_Id == data.message_id
              ? markEdited(msg, data, "Team_Message_Text")
              : msg;
          })
        );
        setNewMessages(
          newMessages &&
          newMessages.map((msg) => {
            return msg.message_id == data.message_id
              ? markEdited(msg, data, "message")
              : msg;
          })
        );
      });
    socket &&
      socket.on("grp-chat-all-read", (data) => {
        if (data.unread_msgs && data.unread_msgs.length) {
          setConversations(
            conversations.map((msg) => {
              return data.unread_msgs.includes(msg.Team_Message_Id) ||
                Math.max(data.unread_msgs) >= msg.Team_Message_Id
                ? { ...msg, IsAllRead: true }
                : msg;
            })
          );
          setNewMessages(
            newMessages &&
            newMessages.map((msg) => {
              return data.unread_msgs.includes(msg.message_id) ||
                Math.max(data.unread_msgs) >= msg.message_id
                ? { ...msg, IsAllRead: true }
                : msg;
            })
          );
        }
      });
    socket &&
      socket.on("message-deleted", (data) => {
        // Tombstone instead of removing the row, so everyone in the chat
        // sees "Message deleted" live rather than a message that silently
        // vanished (QA CM-03).
        // Ids compared as strings: the event and the rows don't always
        // agree on number vs string.
        setConversations(
          conversations.map((msg) =>
            String(msg.Team_Message_Id) === String(data.message_id)
              ? markDeleted(msg)
              : msg
          )
        );
        setNewMessages(
          newMessages.map((msg) =>
            String(msg.message_id) === String(data.message_id)
              ? markDeleted(msg)
              : msg
          )
        );
      });
    return () => {
      if (socket) {
        socket.off("get-members");
        socket.off("member-added");
        socket.off("member-removed");
        socket.off("get-members");
        socket.off("grp-chat-all-read");
        socket.off("message-deleted");
        socket.off("message-edited");
      }
    };
  }, [
    conversations,
    newMessages,
    socket,
    currentSChannel,
    currentTeam,
    currentRoute,
  ]);

  // useEffect(() => {
  //   if (socket) {
  //     socket &&
  //       socket.on('get-project-channels', data => {
  //         console.log('get-project-channels,', data)
  //         setProjects(
  //           data.map(item => {
  //             return { ...item, colapse: false }
  //           })
  //         )
  //       })
  //     return () => {
  //       if (socket) {
  //         socket.off('get-project-channels')
  //       }
  //     }
  //   }
  // }, [socket])

  useEffect(() => {
    if (socket) {
      socket &&
        socket.on("get-projects-android", (data) => {
          console.log("get-projects-android response:", data);
          setProjects(
            data.map((item) => {
              return { ...item, colapse: false };
            })
          );
        });
      return () => {
        if (socket) {
          socket.off("get-projects-android");
        }
      };
    }
  }, [socket, sateUpdater]);

  useEffect(() => {
    if (sateUpdater === true) {
      getProjects();
    }
    setSateUpdater(false);
  }, [sateUpdater]);

  useEffect(() => {
    if (socket) {
      socket &&
        socket.on("get-teams-android", (data) => {
          console.log("get-teams-android response:", data);
          setTeams(
            data.map((item) => {
              return { ...item, colapse: false };
            })
          );
        });
      return () => {
        if (socket) {
          socket.off("get-teams-android");
        }
      };
    }
  }, [socket]);

  useEffect(() => {
    if (socket) {
      callInitiat();
      socket.on("call-end", (data) => {
        getCallDetails();
        navigate("/chat");
        setUserCalling(false);
      });
      // socket.on("call-history", (data) => {
      //   console.log("call-history",data);
      //   console.log(callHystory);
      //   setcallsLoading(false)

      //   setCallHystory([ ...callHystory,...data])

      // });
      socket.on("call-reject", (data) => {
        setUserCalling(false);
      });
      socket.on("call-accept", (data) => {
        setCallDetaiils({ ...callDetaiils, ...data });
        setUserCalling(false);
        localStorage.setItem(
          "callDetaiils",
          JSON.stringify({ ...callDetaiils, ...data })
        );
        let username = localStorage.getItem("Username");
        // window.open("/jitsi/" + data.call_id + "/" + data.room_id + "/" + username, "_blank")
        navigate(
          "/jitsi/" + data.call_id + "/" + data.room_id + "/" + username,
          "_blank"
        );
      });

      return () => {
        if (socket) {
          socket.off("get-members");
          socket.off("call-initiate");
          socket.off("call-end");
          socket.off("call-accept");
        }
      };
    }
  }, [socket, callDetaiils]);

  useEffect(() => {
    let timeout = null;
    let audio = new Audio(ringtone);
    if (userCalling) {
      audio.play();
      timeout = setTimeout(() => {
        setUserCalling(false);
        if (callDetaiils.call_id) {
          socket &&
            socket.emit("call-reject", { call_id: callDetaiils.call_id });
        }
      }, 60000);

      socket && socket.off("call-initiate");
    } else {
      if (timeout) clearTimeout(timeout);
      audio.pause();
      callInitiat();
    }
  }, [socket, userCalling]);

  const callInitiat = () => {
    socket &&
      socket.on("call-initiate", (data) => {
        setUserCalling(true);
        localStorage.setItem(
          "callDetaiils",
          JSON.stringify({ ...callDetaiils, ...data })
        );
        setCallDetaiils({ ...callDetaiils, ...data });
      });
  };
  const getPrivateChatConversation = (pagination) => {
    setLoading(true);
    socket &&
      socket.emit("get-conversation", { schannel_id: currentSChannel, page });
  };

  useEffect(() => {
    if (currentSChannel) {
      getPrivateChatConversation();
      setConversations([]);
      setPage(0);
      setNewMessages([]);
    }
    if (currentSChannel) {
      socket && socket.emit("get-members", { schannel_id: currentSChannel });
    }
    return () => {
      socket && socket.off("get-members");
    };
  }, [currentSChannel, socket]);

  const sendMessage = async (
    msg,
    fileArray,
    replyTo,
    menstionedUsers,
    userId,
    aitrue
  ) => {
    if (msg.trim().length === 0 && fileArray.length === 0) return;

    if (msg.includes("@")) {
      let regex = /@\[.+?\]\(.+?\)/gm;
      let displayRegex = /@\[.+?\]/g;
      let idRegex = /\(.+?\)/g;
      let matches = msg.match(regex);
      let arr = [];
      let str = "";
      matches &&
        matches.forEach((m) => {
          let display = m
            .match(displayRegex)[0]
            .replace("[", "")
            .replace("]", "");
          arr.push(display);
        });
      let newComment = msg.split(regex);

      for (let i = 0; i < newComment.length; i++) {
        const element = newComment[i];
        str += element + `${arr[i]}`.replace("undefined", "");
      }
      msg = str;
    }

    const mentionedUserIdArr =
      menstionedUsers && menstionedUsers.map((user) => user.id);

    let files = [];
    if (fileArray && fileArray.length) {
      files = await uploadFiles(fileArray);
    }
    // The upload was refused or failed, and uploadFiles has said why. Don't
    // send the caption on its own as if the file had gone with it; `false`
    // tells the composer to put the text and files back (QA CM-07).
    if (fileArray && fileArray.length && !files) return false;

    let sender =
      activeChat &&
      activeChat.em &&
      activeChat.em.filter((user) => user?.User_Id == userData?.EmpId)[0];
    let data = {
      aiCond: aitrue,
      user_send: userId,
      sender_name:
        aitrue === true
          ? "Vehicle Ai assistant"
          : sender?.FirstName + " " + sender?.LastName,
      message: msg.trim(),
      schannel_id: currentSChannel,
      files: files?.map((file) => file.path),
      ReplyTo: (replyTo && replyTo.Team_Message_Id) || replyTo.message_id,
      Mentioned_To: mentionedUserIdArr.join(","),
      device_type: "web",
      schannel_name:
        activeChat && activeChat.Team_Channel_Name
          ? activeChat.Team_Channel_Name
          : "",
      channel_name: activeChat && activeChat.project ? activeChat.project : "",
      chat_type:
        activeChat && activeChat.Team_Channel_Name != undefined
          ? "channel"
          : "message",
      channel_id:
        activeChat && activeChat.channel_id ? activeChat.channel_id : "",
      PhotoPath: userData?.Image,
    };
    console.log("data,", data);

    (msg || files?.length) && socket && socket.emit("send-message", data);
    return true;

    // let users = recentChats
    // let inde = users.findIndex((i) => { return i.Team_Channel_Id == currentSChannel })

    // let user = users.splice(inde, 1)

    // setRecentChats([...user, ...users])
  };
  const [fileLoader, setFileLoader] = useState(false);
  // In-flight upload wrappers surfaced to the UI so users get a progress bar
  // for large files. Each entry is `{ id, batchId, file, name, size, type,
  // progress }` — the real File ref is preserved so UploadTray can still call
  // URL.createObjectURL for thumbnails. Wrappers are added before the request
  // and removed in `finally`, so an aborted/failed upload doesn't leave a
  // ghost row in the tray.
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const uploadFiles = async (fileArray) => {
    console.log(fileArray);
    // What to tell the user when the chat server refuses the upload (QA
    // CM-07): its own message when it sends one, otherwise a reason read
    // from the status code. Before, a refusal was only logged, and the
    // tray had already been cleared, so the file just disappeared.
    const uploadRefusal = (res) => {
      const serverMessage = res?.json?.message;
      if (typeof serverMessage === "string" && serverMessage.trim()) {
        return serverMessage.trim();
      }
      const status = res?.response?.status;
      if (status === 413) return "The file is too large for the server, so nothing was sent.";
      if (status === 415) return "This file type can't be sent, so nothing was sent.";
      return "The file couldn't be uploaded, so nothing was sent. Try again.";
    };
    let formData = new FormData();
    if (Array.isArray(fileArray) && fileArray.length)
      for (let index = 0; index < fileArray.length; index++) {
        var element = fileArray[index];
        formData.append("file", element);
      }

    formData.append("schannel_id", currentSChannel);

    // Batch ID groups all files in this single multipart request — the server
    // takes them as one upload, so the XHR's progress event reports a single
    // loaded/total for the whole batch. We mirror that batch percent onto
    // every wrapper in the group rather than fabricating per-file numbers.
    const batchId = `${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    const wrappers = (Array.isArray(fileArray) ? fileArray : []).map(
      (file, idx) => ({
        id: `${batchId}-${idx}`,
        batchId,
        file,
        name: file?.name,
        size: file?.size,
        type: file?.type,
        progress: 0,
      })
    );
    if (wrappers.length) {
      setUploadingFiles((prev) => [...prev, ...wrappers]);
    }

    try {
      setFileLoader(true);
      let res = await postMultipartWithProgress(
        ApiConfig.UPLOAD_CHAT_FILES,
        formData,
        (percent) => {
          setUploadingFiles((prev) =>
            prev.map((w) =>
              w.batchId === batchId ? { ...w, progress: percent } : w
            )
          );
        }
      );
      let json = res.json;
      if (res?.response?.ok && json && json.success) {
        return json.data;
      }
      toast.error(uploadRefusal(res));
      return null;
    } catch (error) {
      console.log("catch error of fileUpload,", error);
      toast.error(uploadRefusal(null));
      return null;
    } finally {
      setFileLoader(false);
      if (wrappers.length) {
        setUploadingFiles((prev) =>
          prev.filter((w) => w.batchId !== batchId)
        );
      }
    }
  };

  const [Newpermissions, setNewpermissions] = useState({});

  useEffect(() => {
    socket &&
      socket.on("access-view", (value) => {
        let data = value.data;

        setNewpermissions(data);
        getUpdatedPermission();

        // seChatCount(data?.allUnreadMsgs);
      });
    return () => {
      socket && socket.off("access-view");
    };
  }, [socket]);

  const getUpdatedPermission = () => {
    simpleGetCallWithToken(ApiConfig.GET_USER_PERMISSIONS + userData?.EmpId)
      .then((res) => {
        if (res?.Success) {
          setPremissions(res?.Data);

          localStorage.setItem("Permissions", JSON.stringify(res?.Data));
        } else {
          console.log("something went wrong");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //  Chat bot Admin
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const [token, setToken] = useState("");

  const [selectedDomainId, setSelectedDomain] = useState("");

  const [search, setSearch] = useState("");
  const [HeaderDynamic, setHeaderDynamic] = useState("");

  const [chats, setChats] = useState([]);

  const [domainName, setDomainName] = useState("");
  console.log("domainName", domainName);

  const [backTo, setBackTo] = useState("");

  const [addInExisting, setAddInExisting] = useState({
    answer: "",
    intent: "",
    keyword: "",
    productModule: "",
  });

  const [editKewordDtls, setEditKeyWordDtls] = useState(null);
  const getChatList = () => {
    postRequest(
      ApiConfig.GET_CHAT_USERS,
      JSON.stringify({
        search: search,
        domain_id: selectedDomainId,
      })
    ).then((res) => {
      if (res?.success) {
        setChats(res?.chatbot_inquiry);
      } else {
        setChats([]);
      }
    });
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      getChatList();
    }, 2000);
    return () => clearTimeout(getData);
  }, [search, selectedDomainId]);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIsDrawerOpen(false);
    } else {
      setIsDrawerOpen(true);
    }
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getCountryList = () => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_COUNTRY_LIST).then((res) => {
      if (!res?.error) {
        console.log("dattttttt", res);

        setCountryList({
          countries: res.json.Data,
          isFetched: true,
        });
      }
    });
  };

  // domains logic here
  const [domains, setDomains] = useState([]);
  const getDomains = () => {
    getRequest(ApiConfig.GET_DOMAINS )
      .then((res) => {
        // console.log(res);
        if (res.success) {

          const payLoadData = {
                EmpId: Number(userData.EmpId),
                OrgId: Number(userData.OrgId),
              };
              PostCallWithErrorResponse(
                ApiConfig.EMP_PROJECTS_NAMES,
                JSON.stringify(payLoadData)
              ).then((response) => {

                let assignedProjectNameWithDomains = [];
                
                response?.json?.Data?.forEach((project)=>{

                  

                   res?.data?.forEach((domain)=>{

                    if(project.ProjectId==domain.wifi_project_id){

                      assignedProjectNameWithDomains.push({...domain,
                        projectName:project?.ProjectName
                      })

                    }

                   })

                })

                console.log(assignedProjectNameWithDomains,'domains');
                
              setSelectedDomain(assignedProjectNameWithDomains[0]?.id||'');
              setomainMapsWithProject(assignedProjectNameWithDomains)
              setSelectedProjectName(assignedProjectNameWithDomains[0]?.projectName||"")

              setDomainName(assignedProjectNameWithDomains[0]?.projectName||"");
                // setProjectNames(res.json.Data);
              });

          setDomains(res.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getDomains();
  }, [token]);

  const [slideOpen, setSlideOpen] = useState(true);

  const getMasterData = () => {
    if (masterData?.isFetched) return;

    simpleGetCallWithErrorResponse(ApiConfig.MASTER_DATA).then((res) => {
      if (res?.json?.success) {
        let masterData = {
          isFetched: true,
        };

        res?.json?.data?.forEach((data, index) => {
          masterData[data?.listName] = data["listValues"];
        });

        setMasterData(masterData);
      }
    });
  };

  const getTaskAllocationStatus = () => {
    if (taskAllocationStatus.length > 0) return;

    simpleGetCallWithErrorResponse(ApiConfig.GET_TASK_ALLOCATION_STATUS).then(
      (res) => {
        if (res?.json?.success) {
          setTaskAllocationStatus(res?.json?.data);
        }
      }
    );
  };

  const getTeamList = () => {
    if (teamList.length > 0) return;

    simpleGetCallWithErrorResponse(ApiConfig.GET_TEAM_LIST).then((res) => {
      if (res?.json?.Success) {
        setTeamList(res?.json?.Data);
      }
    });
  };

  useEffect(() => {
    fetchDropdownList();
  }, []);

  // The header's store picker needs this list on every page, but only
  // for tenants with a CRM node URL and key: for everyone else the call
  // went to "undefinedapi/v1/..." and failed on every page. It is also
  // fetched once, not again from Login and Dashboard on top of the mount
  // effect; `force` re-fetches after a store is added.
  const fetchDropdownList = async ({ force = false } = {}) => {
    const crmBase = userData?.CRMUrlNode;
    const wifiKey = localStorage.getItem("WifiApiKey");
    if (!crmBase || /^(undefined|null)\/?$/.test(crmBase) || !wifiKey) return;
    if (!force && Array.isArray(storesList) && storesList.length > 0) return;
    try {
      const res = await simpleGetCall(
        crmBase + "api/v1/shops/storeDropDown/", //live
        // "https://staging.crm-api.wifiattendance.com:3017/" + "api/v1/shops/storeDropDown/"  //stage
        // "https://tunnel.cloudvolte.com/" + "api/v1/shops/storeDropDown/"  //vinod pc
        // "http://localhost:3016/" + "api/v1/shops/storeDropDown/", //local
        { "x-wifi-api-key": localStorage.getItem("WifiApiKey") ?? "" }
      );

      // A failed call (the CRM API answers 500 at the moment) returns no
      // `stores`; that is "no stores", not an exception to log.
      const storeList = (Array.isArray(res?.stores) ? res.stores : []).map((store) => ({
        value: store.id,
        label: store.restaurant_name,
        id: store.restID,
      }));
      setstoresList(storeList);

      // Bring back the restaurant chosen before a page refresh (F5).
      // selectedRestID was already restored from localStorage (above), but
      // selectedStoreID was not, so after a refresh Kitchen Management, Print
      // Settings and the Edit Printer page all sat on "Choose a restaurant"
      // (Edit Printer loaded forever). Every store picker saves its choice as
      // "selectedStoreId".
      //
      // Matched against the list rather than used as-is, for two reasons:
      // localStorage holds the STRING "190" while pickers compare the numeric
      // value with ===, and a restaurant this user can no longer see must not
      // come back. `cur ||` never overrides a choice made while this loaded.
      const saved = localStorage.getItem("selectedStoreId");
      const hit = saved ? storeList.find((s) => String(s.value) === saved) : null;
      if (hit) {
        setSelectedStoreID((cur) => cur || hit.value);
        setSelectedRestName((cur) => cur || hit.label);
      }
    } catch (err) {
      console.error("Dropdown API Error:", err);
    }
  };

  const handleNavigate = () => {
    if (
      permissions &&
      (permissions["View Calendar"] ||
        permissions["My Task"] ||
        permissions["Alert Notification"] ||
        permissions["Timesheet"] ||
        permissions["Check In / Out"])
    ) {
      navigate("Dashboard");
    } else {
      navigate("/projects");
    }
  };

  const storeLoginData = async (res, setLoggedIn) => {
    setToken(res.json.Data.Token);
    setSelectedCRMURL(res.json.Data.CRMUrlNode)
    setUserData({
      Token: res.json.Data.Token,
      Username: res.json.Data.Username,
      UserId: res.json.Data.UserId,
      Mobile: res.json.Data.Mobile,
      Permissions: res.json.Data.Permissions,
      EmpId: res.json.Data.EmpId,
      OrgId: res.json.Data.OrgId,
      Email: res.json.Data.Email,
      LastName: res.json.Data.LastName,
      FirstName: res.json.Data.FirstName,
      Image: res.json.Data.Image,
      IsActive: res.json.Data.IsActive,
      CompanyLogo: res.json.Data.CompanyLogo,
      CRMUrlNode:  res.json.Data.CRMUrlNode +  (res.json.Data.CRMUrlNode?.endsWith("/") ? "" : "/"),
      CRMUrlPython: res.json.Data.CRMUrlPython,
      locationId: res?.json?.Data?.LocationId

    });

    setHeaderProfile(res?.json?.Data?.Image);
    setOpenSessionLogoutModal(false);
    localStorage.setItem("Username", res.json.Data.Username);
    localStorage.setItem("Email", res.json.Data.Email);
    localStorage.setItem("Token", res.json.Data.Token);
    localStorage.setItem("Mobile", res.json.Data.Mobile);
    localStorage.setItem("IsActive", res.json.Data.IsActive);
    localStorage.setItem("EmpId", res.json.Data.EmpId);
    localStorage.setItem("OrgId", res.json.Data.OrgId);
    localStorage.setItem("UserId", res.json.Data.UserId);
    localStorage.setItem("FirstName", res.json.Data.FirstName);
    localStorage.setItem("LastName", res.json.Data.LastName);
    localStorage.setItem("Image", res.json.Data.Image);
    localStorage.setItem("CompanyLogo", res.json.Data.CompanyLogo);
    localStorage.setItem("CRMUrlNode", res.json.Data.CRMUrlNode+(res.json.Data.CRMUrlNode?.endsWith("/") ? "" : "/"));

    localStorage.setItem("CRMUrlPython", res.json.Data.CRMUrlPython);
    localStorage.setItem("logedIn", true);
    localStorage.setItem("locationId", res?.json?.Data?.LocationId);
    localStorage.setItem('appSettings', JSON.stringify(res?.json?.Data?.appSettings));

    //workflow login stroage
    localStorage.setItem("token", res.json.Data.Token);
    localStorage.setItem("status", "Active");
    localStorage.setItem("userId", res.json.Data.UserId);
    localStorage.setItem("role", res.json.Data.Role);
    localStorage.setItem("roleId", res.json.Data.RoleId);
    localStorage.setItem("wfmuser", res.json.Data.FirstName);
    localStorage.setItem("currentUser", res.json.Data);
    localStorage.setItem("WalletApiKey", "wk_2e5948486cb92d09b54368cd96334870e33b929a92d55e34");

    const wdata = {
      token: res.json.Data.Token,
      role: res.json.Data.Role,
      RoleId: res.json.Data.RoleId,
      userId: res.json.Data.UserId,
      empId: res.json.Data.EmpId,
      OrgId: res.json.Data.OrgId,
      mobile: res.json.Data.Mobile,
      Username: res.json.Data.Username,
      firstName: res.json.Data.FirstName,
      status: "Active",
      // Password: user.Password,
      device_Id: "string",
      MacId: "string",
      Platform: "WebApp",
    };
    //
    //localStorage.setItem("encrypted", encrypted.data);
    //console.log("encrypted",encrypted.data);
    // const secretKey = 'my-fixed-secret-key-12345';

    //const decryptedData = await CryptoJS.AES.encrypt(wdata, secretKey).toString(CryptoJS.enc.Utf8);
    //  console.log("encrypted", encrypted);

    const secretKey = "your-secret-key";

    // const encrypted = await encryptData(JSON.stringify(wdata), secretKey);

    // console.log("encrypted", encrypted);
    setLoggedIn(true);
    fetchDropdownList()

    localStorage.setItem(
      "Permissions",
      JSON.stringify(res.json.Data.Permissions)
    );
    setPremissions(res?.json?.Data?.Permissions);
    setAppSettings(res?.json?.Data?.AppSettings);


  }

  const [appSettings, setAppSettings] = useState(localStorage.getItem('appSettings') ? JSON.parse(localStorage.getItem("appSettings")) : {});
  const location = useLocation();
  const [backDropOpen, setBackDropOpen] = useState(false);
  const [hideCopy, setHideCopy] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [productNameWidth, setProductNameWidth] = useState(false);
  const [hideBothSide, setHideBothSide] = useState({
    lg: "8",
    displayBlock: "",
  });

  const [units, setUnits] = useState([]);
  const userLoginData = localStorage.user
    ? JSON.parse(localStorage.getItem("user"))
    : {};

  const financialYear = localStorage.financialYear
    ? JSON.parse(localStorage.financialYear)
    : {};
  const { financialYearId } = financialYear;
  const company_details = localStorage.company_details
    ? JSON.parse(localStorage.company_details)
    : {};

  const getYearFromJoiningOfLoginUser = () => {
    if (yearsFromJoining.isFetch) return;

    simpleGetCallWithErrorResponse(
      ApiConfig.GET_YEARS_FROM_JOINING + userData.EmpId
    ).then((res) => {
      if (res?.json?.Success) {
        setYearsFromJoining({
          isFetch: true,
          years: res?.json?.Data,
        });
      }
    });
  };

  // Memoize the context value so the provider doesn't hand a brand-new
  // object to every consumer on every render. Deps list state values only —
  // useState setters are stable refs and don't need to be listed; inline
  // functions defined in this component are intentionally excluded (they'd
  // invalidate the memo every render until they're wrapped in useCallback in
  // the planned AppState split).
  const contextValue = useMemo(
    () => ({
      workPlaceType,
      setWorkPlaceType,
      slideOpen,
      setSlideOpen,
      sidebar,
      setSidebar,
      noOfRows,
      setNoOfRows,
      Dark,
      setDark,
      backdrop,
      setbackdrop,
      profile,
      setprofile,
      temp,
      settemp,
      userData,
      setUserData,
      activeChat,
      setActiveChat,
      currentSChannel,
      setCurrentSChannel,
      pendingSearchJump,
      setPendingSearchJump,
      socket,
      sateUpdater,
      setSateUpdater,
      unreadCount,
      headerProfile,
      setHeaderProfile,
      filteredUsers,
      searchFilter,
      recentChats,
      newMessages,
      conversations,
      loading,
      paginationLoader,
      setPaginationLoader,
      fetchDropdownList,
      setConversations,
      getPrivateChatConversation,
      page,
      pinnedChats,
      userTyping,
      setUserTyping,
      editMsg,
      setEditMsg,
      setNewMessages,
      noMorePages,
      setPage,
      sendMessage,
      projects,
      setProjects,
      replyTo,
      setReplyTo,
      isLoading,
      userCalling,
      storesList,
      setstoresList,
      setUserCalling,
      setCallDetaiils,
      callDetaiils,
      callHystory,
      suggetions,
      setSuggetions,
      membersArray,
      setMembersArray,
      setLoading,
      setSocket,
      currentTeam,
      setCurrentTeam,
      msgdelete,
      setmsgdelete,
      teamMembers,
      setTeamMembers,
      teamMemberslist,
      setTeamMembersList,
      getCallDetails,
      callsLoading,
      notifications,
      projectIdTast,
      setprojectIdTast,
      callPage,
      setCallPage,
      setPinnedChats,
      setNoMorePages,
      CallLoadMore,
      setCallLoadMore,
      activeTab,
      setActiveTab,
      setRecentChats,
      recentChatLdr,
      setRecentChatLdr,
      openSessionLogoutModal,
      setOpenSessionLogoutModal,
      SubChannelId,
      setSubChannelId,
      teams,
      setTeams,
      fileLoader,
      uploadingFiles,
      setUploadingFiles,
      selectedStoreID,
      setSelectedStoreID,
      setFileLoader,
      permissions,
      HeaderDynamic,
      setHeaderDynamic,
      Newpermissions,
      setNewpermissions,
      setPremissions,
      chatCount,
      unreadProjectCount,
      unreadTeamCount,
      selectedRestID,
      setSelectedRestID,
      SelectedRestName,
      setSelectedRestName,
      isDrawerOpen,
      toggleDrawer,
      domains,
      setDomains,
      selectedDomainId,
      setSelectedDomain,
      storeMenusTabs,
      setStoreMenusTabs,
      chats,
      setToken,
      search,
      setSearch,
      domainName,
      setDomainName,
      backTo,
      setBackTo,
      addInExisting,
      setAddInExisting,
      editKewordDtls,
      setEditKeyWordDtls,
      handleEditDocument,
      deleteDocument,
      downloadDocument,
      countryList,
      getCountryList,
      ChannelId,
      setChannelId,
      setIsCAllHistory,
      isCallHistory,
      getMasterData,
      masterData,
      getTaskAllocationStatus,
      taskAllocationStatus,
      getTeamList,
      teamList,
      loadworkFlowTaskForm,
      setLoadWorkFlowTaskForm,
      getPendingWorkflowTaskCount,
      pendingWorkflowTaskCount,
      parentCategory,
      setParentCategory,
      handleNavigate,
      intentAndKeywords,
      setIntentAndKeywords,
      handleSetBack,
      backNav,
      parentTab,
      setParentTab,
      userlgin,
      setUserlgin,
      PageMsg,
      SetPageMsg,
      codequerylgin,
      setcodequerylgin,
      customerData,
      setCustomerData,
      tokendatacontaxt,
      settokendatacontaxt,
      sethide,
      Pecentagedata,
      setPecentagedata,
      ChangeLang,
      SetChangeLang,
      hide,
      backDropOpen,
      setBackDropOpen,
      percentage,
      setPercentage,
      isNormal,
      setIsNormal,
      uniqueCode,
      setUniqueCode,
      logo,
      setLogo,
      formFormat,
      setFormFormat,
      company_details,
      financialYear,
      financialYearId,
      hideCopy,
      setHideCopy,
      invoiceNo,
      setInvoiceNo,
      userLoginData,
      units,
      setUnits,
      currentRoute,
      productNameWidth,
      setProductNameWidth,
      hideBothSide,
      setHideBothSide,
      navigate,
      appSettings,
      setAppSettings,
      activeTabId,
      setActiveTabId,
      error,
      get,
      post,
      put,
      ApiConfigg,
      ApiConfig: ApiConfigg,
      setApiConfigInr,
      setSelectedCRMURL,
      SelectedCRMURL,
      getYearFromJoiningOfLoginUser,
      yearsFromJoining,
      storeLoginData,
       domainsMapWithProjects,
      selectedProjectName,
      setSelectedProjectName
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      slideOpen, sidebar, noOfRows, Dark, backdrop, profile, temp,
      userData, activeChat, currentSChannel, socket, sateUpdater,
      unreadCount, headerProfile, filteredUsers, searchFilter,
      recentChats, newMessages, conversations, loading, paginationLoader,
      page, pinnedChats, userTyping, editMsg, noMorePages, projects,
      replyTo, isLoading, userCalling, storesList, callDetaiils,
      callHystory, suggetions, membersArray, currentTeam, msgdelete,
      teamMembers, teamMemberslist, callsLoading, notifications,
      projectIdTast, callPage, CallLoadMore, activeTab, recentChatLdr,
      openSessionLogoutModal, SubChannelId, teams, fileLoader,
      uploadingFiles, selectedStoreID, permissions, HeaderDynamic,
      Newpermissions, chatCount, unreadProjectCount, unreadTeamCount,
      selectedRestID, SelectedRestName, isDrawerOpen, domains,
      selectedDomainId, storeMenusTabs, chats, search, domainName,
      backTo, addInExisting, editKewordDtls, countryList, ChannelId,
      isCallHistory, masterData, taskAllocationStatus, teamList,
      loadworkFlowTaskForm, pendingWorkflowTaskCount, parentCategory,
      intentAndKeywords, backNav, parentTab, userlgin, PageMsg,
      codequerylgin, customerData, tokendatacontaxt, Pecentagedata,
      ChangeLang, hide, backDropOpen, percentage, isNormal, uniqueCode,
      logo, formFormat, company_details, financialYear, financialYearId,
      hideCopy, invoiceNo, userLoginData, units, currentRoute,
      productNameWidth, hideBothSide, appSettings, activeTabId, error,
      ApiConfigg, SelectedCRMURL, yearsFromJoining,
     
    ]
  );

  return (
    <div>
      {/* {fileLoader && <BackDropLoader />} */}
      {/* //following backdrop loader is from priston code */}
      <BackDropLoader
        backDropOpen={backDropOpen || isLoading}
        setBackDropOpen={setBackDropOpen}
      />
      <AppContext.Provider value={contextValue}>
        {props.children}
      </AppContext.Provider>
    </div>
  );
};

export default AppState;
